import React from 'react';

const MEDIUM_META = {
    EMAIL: { icon: 'bi-envelope-fill', className: 'activity-medium--email' },
    SMS: { icon: 'bi-chat-text-fill', className: 'activity-medium--sms' },
    CALL: { icon: 'bi-telephone-fill', className: 'activity-medium--call' },
};

const STATUS_META = {
    SENT: { className: 'activity-status--sent', icon: 'bi-check-circle-fill' },
    FAILED: { className: 'activity-status--failed', icon: 'bi-x-circle-fill' },
    QUEUED: { className: 'activity-status--queued', icon: 'bi-hourglass-split' },
    WAITING: { className: 'activity-status--waiting', icon: 'bi-clock-history' },
    RESEND: { className: 'activity-status--resend', icon: 'bi-arrow-repeat' },
};

function ActivityStatusBadge({ status }) {
    const meta = STATUS_META[status] || STATUS_META.WAITING;

    return (
        <span className={`activity-status ${meta.className}`}>
            <i className={`bi ${meta.icon}`}></i>
            {status || 'UNKNOWN'}
        </span>
    );
}

function ActivityMediumBadge({ mediumType }) {
    const meta = MEDIUM_META[mediumType] || { icon: 'bi-question-circle', className: 'activity-medium--default' };

    return (
        <span className={`activity-medium ${meta.className}`}>
            <i className={`bi ${meta.icon}`}></i>
            {mediumType || 'Unknown'}
        </span>
    );
}

function ActivityListItem({ item, onViewDetails }) {
    const patientLabel = item.patientName
        || [item.firstName, item.lastName].filter(Boolean).join(' ')
        || item.preferredName
        || 'Unknown patient';

    return (
        <article className="activity-item ecx-page-list-item">
            <div className="activity-item__header">
                <div className="activity-item__main">
                    <span className="ecx-page-icon-badge activity-item__icon">
                        <i className={`bi ${MEDIUM_META[item.mediumType]?.icon || 'bi-activity'}`}></i>
                    </span>

                    <div className="activity-item__content">
                        <div className="activity-item__title" title={item.activityName || 'Untitled activity'}>
                            {item.activityName || 'Untitled activity'}
                        </div>
                        <div className="activity-item__patient" title={patientLabel}>
                            <i className="bi bi-person me-1 flex-shrink-0"></i>
                            <span className="text-truncate">{patientLabel}</span>
                        </div>
                    </div>
                </div>

                <div className="activity-item__aside">
                    <div className="activity-item__actions">
                        <ActivityStatusBadge status={item.status} />
                        <ActivityMediumBadge mediumType={item.mediumType} />
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => onViewDetails(item)}
                        >
                            <i className="bi bi-eye me-1"></i>
                            Details
                        </button>
                    </div>
                    <span className="activity-item__datetime">
                        <i className="bi bi-calendar3 me-1"></i>
                        {item.createdAt || '—'}
                    </span>
                </div>
            </div>
        </article>
    );
}

export default ActivityListItem;
